"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var uuid_1 = require("uuid");
var EventRegistry = /** @class */ (function () {
    function EventRegistry() {
        this.callbacks = {};
    }
    EventRegistry.prototype.on = function (eventName, callback, filter) {
        var _this = this;
        this.callbacks[eventName] = this.callbacks[eventName] || {};
        var id = uuid_1.v4();
        this.callbacks[eventName][id] = { callback: callback, filter: filter };
        return function () {
            delete _this.callbacks[eventName][id];
        };
    };
    EventRegistry.prototype.emit = function (eventName, data) {
        if (this.callbacks[eventName]) {
            Object.values(this.callbacks[eventName]).forEach(function (filterableCallback) {
                if (filterableCallback.filter && filterableCallback.filter(data) === false)
                    return;
                filterableCallback.callback(data);
            });
        }
    };
    return EventRegistry;
}());
exports.default = EventRegistry;
//# sourceMappingURL=EventRegistry.js.map